const Scrollable = ({
  children,
  maxHeight,
  className
}: {
  children: React.ReactNode
  maxHeight?: string
  className?: string
}) => (
  <div className={`overflow-y-hidden`}>
    <div className='overflow-auto' style={{ maxHeight }}>
      {children}
    </div>
  </div>
)

export default Scrollable
